const SCREENSHOTS_MARKER = 'Screenshots:';
const VIDEOS_MARKER = 'Videos:';

const toUrlList = (section: string): string[] =>
  section
    .split('\n')
    .map(line => line.trim())
    .filter(Boolean);

// The lender lambda task appends "Screenshots: <urls>" and/or "Videos: <urls>" (one url per line) to apiDetail.
export const parseApiDetailArtifacts = (
  apiDetail: unknown
): { detail: any; screenshots: string[]; videos: string[] } => {
  if (apiDetail === null || apiDetail === undefined) {
    return { detail: apiDetail, screenshots: [], videos: [] };
  }

  const text = apiDetail.toString();
  const markers = [SCREENSHOTS_MARKER, VIDEOS_MARKER]
    .map(marker => ({ marker, index: text.indexOf(marker) }))
    .filter(({ index }) => index !== -1)
    .sort((a, b) => a.index - b.index);

  if (!markers.length) {
    return { detail: apiDetail, screenshots: [], videos: [] };
  }

  const result = { detail: text.slice(0, markers[0].index), screenshots: [] as string[], videos: [] as string[] };

  markers.forEach(({ marker, index }, i) => {
    const end = i + 1 < markers.length ? markers[i + 1].index : text.length;
    const urls = toUrlList(text.slice(index + marker.length, end));
    if (marker === SCREENSHOTS_MARKER) {
      result.screenshots = urls;
    } else {
      result.videos = urls;
    }
  });

  return result;
};

export interface MultimediaLink {
  url: string;
  label: string;
}

export const getMultimediaLinks = (entity: any): MultimediaLink[] => [
  ...(entity?.apiScreenshots ?? []).map((url: string, i: number) => ({ url, label: `image-${i + 1}` })),
  ...(entity?.apiVideos ?? []).map((url: string, i: number) => ({ url, label: `video-${i + 1}` })),
];
